import { BED_JOINT_GAP_MM, DEFAULT_PERPEND_GAP_MM, EPSILON } from './constants.js';
import type { Mm } from './units.js';

export interface Rect {
  readonly x: Mm;
  readonly y: Mm;
  readonly width: Mm;
  readonly height: Mm;
}

export interface JointSizes {
  readonly perpendGapMm?: Mm;
  readonly bedGapMm?: Mm;
}

/**
 * SPECIFICATION.md clause 4.2 — the single rule that governs every placement.
 *
 * Two rectangles are compatible when they are separated by at least a full
 * joint on AT LEAST ONE axis. The disjunction is essential: requiring both
 * axes would forbid every stacked course, requiring neither would allow
 * overlap. One clear axis is exactly what staggered bonded masonry needs.
 */
export function rectanglesHaveMortarClearance(
  a: Rect,
  b: Rect,
  { perpendGapMm = DEFAULT_PERPEND_GAP_MM, bedGapMm = BED_JOINT_GAP_MM }: JointSizes = {},
): boolean {
  const separatedX =
    a.x + a.width <= b.x - perpendGapMm + EPSILON ||
    a.x >= b.x + b.width + perpendGapMm - EPSILON;
  const separatedY =
    a.y + a.height <= b.y - bedGapMm + EPSILON ||
    a.y >= b.y + b.height + bedGapMm - EPSILON;
  return separatedX || separatedY;
}
